"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _reactComponents = require("@cimpress/react-components");

var _react = _interopRequireDefault(require("react"));

var DEFAULT_INTERVAL = 300;
var ENTER_KEY = 13;

var CooldownTextField =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(CooldownTextField, _React$PureComponent);

  function CooldownTextField(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CooldownTextField);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CooldownTextField).call(this, props));
    _this.state = {
      prevValue: null
    };

    _this.handleChange = function (value) {
      var handleValueChange = _this.props.handleValueChange;
      clearTimeout(_this.timer);
      handleValueChange(value);
      _this.timer = setTimeout(_this.triggerChange, DEFAULT_INTERVAL);
    };

    _this.clearValue = function () {
      var handleValueChange = _this.props.handleValueChange;
      handleValueChange('');
    };

    _this.handleKeyDown = function (e) {
      if (e.keyCode === ENTER_KEY) {
        _this.triggerChange();
      }
    };

    _this.triggerChange = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          triggerChange = _this$props.triggerChange;

      if (value && _this.state.prevValue !== value) {
        triggerChange(value);
      }
    };

    _this.timer = null;
    return _this;
  }

  (0, _createClass2.default)(CooldownTextField, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          rightIcon = _this$props2.rightIcon,
          handleValueChange = _this$props2.handleValueChange,
          triggerChange = _this$props2.triggerChange,
          cooldownInterval = _this$props2.cooldownInterval,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["value", "rightIcon", "handleValueChange", "triggerChange", "cooldownInterval"]);
      var rightIconToRender = value && value !== '' ? 'close-l' : rightIcon || 'search-l';
      return _react.default.createElement("div", {
        style: {
          position: 'relative'
        }
      }, _react.default.createElement(_reactComponents.TextField, Object.assign({
        value: value,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown
      }, rest)), _react.default.createElement("div", {
        style: {
          position: 'absolute',
          top: '14px',
          right: '12px'
        }
      }, _react.default.createElement("span", {
        style: {
          cursor: 'pointer'
        }
      }, _react.default.createElement(_reactComponents.Icon, {
        name: rightIconToRender,
        onClick: this.clearValue,
        color: _reactComponents.colors.info.darkest
      }))));
    }
  }]);
  return CooldownTextField;
}(_react.default.PureComponent);

exports.default = CooldownTextField;
CooldownTextField.defaultProps = {
  cooldownInterval: DEFAULT_INTERVAL
};